import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBracketsCurly16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconBracketsCurly16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.084 2.084C4.544 1.624 5.222 1.5 6 1.5a.5.5 0 0 1 0 1c-.722 0-1.045.127-1.209.291S4.5 3.278 4.5 4v1c0 .913-.451 1.783-1.084 2.416a4 4 0 0 1-.645.524q.334.18.624.436C4.069 8.976 4.5 9.864 4.5 11v1c0 .722.127 1.045.291 1.209S5.278 13.5 6 13.5a.5.5 0 0 1 0 1c-.778 0-1.455-.123-1.916-.584S3.5 12.778 3.5 12v-1c0-.864-.32-1.476-.77-1.876C2.27 8.715 1.643 8.5 1 8.5a.5.5 0 0 1 0-1c.587 0 1.217-.299 1.709-.791S3.5 5.587 3.5 5V4c0-.778.123-1.455.584-1.916M9.5 2a.5.5 0 0 1 .5-.5c.778 0 1.455.123 1.916.584S12.5 3.222 12.5 4v1c0 .587.299 1.217.791 1.709S14.413 7.5 15 7.5a.5.5 0 0 1 0 1c-.643 0-1.27.215-1.73.624-.45.4-.77 1.012-.77 1.876v1c0 .778-.123 1.455-.584 1.916S10.778 14.5 10 14.5a.5.5 0 0 1 0-1c.722 0 1.045-.127 1.209-.291s.291-.487.291-1.209v-1c0-1.136.43-2.024 1.105-2.624q.29-.255.624-.436a4 4 0 0 1-.645-.524C11.95 6.783 11.5 5.913 11.5 5V4c0-.722-.127-1.045-.291-1.209S10.722 2.5 10 2.5a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBracketsCurly16);
